export const TAB_ROUTE_PREFIX = {
  HOME: "/(tabs)/(home)",
  NOTIFICATIONS: "/(tabs)/notifications",
  ANALYSIS: "/(tabs)/analysis",
  PORTFOLIOS: "/(tabs)/portfolios",
  MENU: "/(tabs)/menu"
};
